import React from 'react';
import { FiMapPin, FiUsers, FiPlus } from 'react-icons/fi';

const Features = () => {
  const features = [
    {
      icon: FiMapPin,
      title: 'Find Matches Across Bangladesh',
      description: 'Discover games in Dhaka, Chittagong, Sylhet and beyond with location-based search across all major cities.',
    },
    {
      icon: FiUsers,
      title: 'Real-Time Notifications',
      description: 'Get instant alerts with sound notifications when someone joins, messages arrive, or match updates happen.',
    },
    {
      icon: FiPlus,
      title: 'Create & Organize Matches',
      description: "Organize your own matches instantly and let players join. Full control over participants and match details.",
    },
    {
      icon: FiUsers,
      title: 'Player Profiles & Ratings',
      description: 'View player histories, ratings, and experience to find compatible teammates and competitive opponents.',
    },
    {
      icon: FiMapPin,
      title: 'Group Chat & Coordination',
      description: 'Built-in messaging for match participants to coordinate, discuss strategy, and connect before/after games.',
    },
    {
      icon: FiPlus,
      title: 'Instant Join System',
      description: 'Browse available slots, see match details, and join games in seconds with one-click confirmation.',
    },
  ];

  return (
    <section className="bg-dark py-20 px-4 md:px-8 relative overflow-hidden">
      {/* Background gradient effects */}
      <div className="absolute top-20 right-10 w-80 h-80 bg-red-500/10 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-0 left-20 w-60 h-60 bg-red-500/5 rounded-full blur-3xl -z-10"></div>
      
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <p className="text-red-500 font-semibold text-sm uppercase tracking-wider">✨ Features</p>
          <h2 className="text-5xl md:text-6xl font-bold text-white">
            Everything you need to <span className="text-gradient">play</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">Powerful tools to find matches, coordinate teams, and build your sports community</p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="card-base card-hover p-8 group relative overflow-hidden"
              >
                {/* Background gradient on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-red-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10 space-y-4">
                  <div className="flex items-center justify-center w-14 h-14 bg-gradient-to-br from-red-500/20 to-red-500/10 rounded-lg group-hover:from-red-500 group-hover:to-red-600 transition-all duration-300">
                    <Icon className="w-7 h-7 text-red-500 group-hover:text-white transition-colors" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-white group-hover:text-red-500 transition-colors">
                    {feature.title}
                  </h3>
                  
                  <p className="text-gray-400 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
